import { createHttpLink } from '@apollo/client';
import { axios } from './DataLoader';

// Create custom fetch function using your axios instance with full fetch API compatibility
const customAxiosFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    // Extract URL from input
    let url: string;
    let requestInit = init || {};

    if (typeof input === 'string') {
        url = input;
    } else if (input instanceof URL) {
        url = input.toString();
    } else if (input instanceof Request) {
        url = input.url;
        // If input is a Request object, merge its properties with init
        requestInit = {
            method: input.method,
            headers: input.headers,
            body: await input.text(),
            ...init // init takes precedence
        };
    } else {
        url = (input as any).toString();
    }

    // Extract method and headers from requestInit
    const method = requestInit.method || 'GET';

    // Convert headers to plain object
    let headers: Record<string, string> = {
        'Content-Type': 'application/json'
    };

    if (requestInit.headers) {
        if (requestInit.headers instanceof Headers) {
            requestInit.headers.forEach((value, key) => {
                headers[key] = value;
            });
        } else if (Array.isArray(requestInit.headers)) {
            // Handle [string, string][] format
            requestInit.headers.forEach(([key, value]) => {
                headers[key] = value;
            });
        } else {
            // Handle Record<string, string> format
            headers = { ...headers, ...(requestInit.headers as Record<string, string>) };
        }
    }

    // Parse body if it exists
    let data;
    if (requestInit.body) {
        if (typeof requestInit.body === 'string') {
            try {
                data = JSON.parse(requestInit.body);
            } catch {
                data = requestInit.body;
            }
        } else {
            data = requestInit.body;
        }
    }

    try {
        const response = await axios({
            url,
            method: method.toUpperCase(),
            data,
            headers
            // JWT token will be automatically added by your axios interceptors
        });

        // Create a proper Response object
        const responseBody = JSON.stringify(response.data);

        return new Response(responseBody, {
            status: response.status,
            statusText: response.statusText,
            headers: new Headers(response.headers as Record<string, string>)
        });
    } catch (error: any) {
        // Handle axios errors and convert to Response
        if (error.response) {
            const responseBody = JSON.stringify(error.response.data || { error: 'Request failed' });
            return new Response(responseBody, {
                status: error.response.status,
                statusText: error.response.statusText,
                headers: new Headers(error.response.headers as Record<string, string>)
            });
        }

        // For network errors or other issues, create a network error response
        return new Response(JSON.stringify({ error: error.message || 'Network error' }), {
            status: 0,
            statusText: 'Network Error'
        });
    }
};

// Create HTTP link
export const apolloLink = createHttpLink({
    uri: '/api-graphql/graphql',
    fetch: customAxiosFetch
});
